export default __webpack_public_path__ + "b35f7648d766b4ec9d12fd6685c9b293.png";